import React from "react";
import { images } from "..";

const Mentorship = () => {
    return (
        <div className="sixth-section py-md-5">
            <img src={images
                .dotsPurple} alt="" className="img-fluid sixth-section-img" />
            <div className="container py-5">
                <div className="row mx-0 justify-content-center">
                    <div className="col-md-7 text-center">
                        <h1 className='heading mb-0'>
                            In Proud Partnership with Compass Point Mentorship!
                        </h1>
                        <p className="summary mt-3">
                            CP Mentorship is a community leading non-profit dedicated to the mentorship and development of youths in the Bay Area and beyond. To learn more, please visit <a href="https://www.cpmentorship.org" target={'_blank'} className="summary" >www.cpmentorship.org</a>
                        </p>
                    </div>
                    <div className="col-12 my-3 text-center">
                        <img src={images.mentorship} alt="mentorship" className="img-fluid mentorship-logo" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Mentorship
